import {
  type SystemAiPolicyPatchV1,
  SystemAiPolicyPatchV1Schema,
  type SystemAiPolicyResponseV1,
  SystemAiPolicyResponseV1Schema,
} from "@adpilot/shared";
import { api } from "./api";

export async function fetchSystemAiPolicy(): Promise<SystemAiPolicyResponseV1> {
  const response = await api.get("settings/ai-policy").json<{ success: true; data: unknown }>();
  return SystemAiPolicyResponseV1Schema.parse(response.data);
}

export async function fetchSystemAiPolicyForShop(
  shopId: string,
): Promise<SystemAiPolicyResponseV1> {
  const response = await api
    .get("settings/ai-policy", { headers: { "X-Shop-Id": shopId } })
    .json<{ success: true; data: unknown }>();
  return SystemAiPolicyResponseV1Schema.parse(response.data);
}

export async function updateSystemAiPolicy(
  patch: SystemAiPolicyPatchV1,
): Promise<SystemAiPolicyResponseV1> {
  const body = SystemAiPolicyPatchV1Schema.parse(patch);
  const response = await api
    .patch("settings/ai-policy", { json: body })
    .json<{ success: true; data: unknown }>();
  return SystemAiPolicyResponseV1Schema.parse(response.data);
}
